export default __webpack_public_path__ + "static/media/pencilMenu.6a3897e2.svg";